/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CalendarType = {
    User: 'user',
    Inventory: 'inventory',
    Additional: 'additional',
    Virtual: 'virtual'
} as const;
export type CalendarType = typeof CalendarType[keyof typeof CalendarType];

